// src/pages/ElectricalWiring.jsx
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../style.css";
import "../components/ElectricalWiring.css";

const pub = process.env.PUBLIC_URL;

export default function ElectricalWiring() {
  useEffect(() => {
    if (window.AOS) window.AOS.refresh();
  }, []);

  return (
    <>
      {/* ────────────────── PAGE HEADER / BREADCRUMB ────────────────── */}
      <section
        className="page-header-breadcrumb"
        data-aos="fade-up"
        style={{ backgroundColor: "var(--bg-light)", padding: "2rem 0" }}
      >
        <h1 className="section-title" style={{ marginBottom: "0.5rem" }}>
          Electrical Wiring Services
        </h1>
        <p className="page-breadcrumb">
          <Link to="/">Home</Link> / <Link to="/services">Services</Link> /{" "}
          <span>Electrical Wiring</span>
        </p>
      </section>

      {/* ───────────────────────── INTRO ────────────────────────────── */}
      <section className="service-intro" data-aos="fade-up">
        <div className="service-intro-content">
          <div
            className="service-intro-image"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <img
              src={`${pub}/Panel wiring1.jpg`}
              alt="Professional Panel Wiring"
            />
          </div>

          <div
            className="service-intro-text"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <h2>Safe&nbsp;&amp;&nbsp;Reliable Electrical Wiring</h2>
            <p>
              Mosike Electrical Contractors delivers expert wiring solutions for
              new builds, renovations and industrial upgrades. All work is
              compliant with SANS&nbsp;10142-1 and tailored to your exact load
              requirements.
            </p>
            <p>
              Our certified electricians cover everything from residential
              circuits to complex MCCs—guaranteeing safety, efficiency and
              longevity for your electrical systems.
            </p>
            <ul className="service-features">
              <li>
                <i className="fas fa-check-circle" /> New Home&nbsp;&amp; Building
                Wiring
              </li>
              <li>
                <i className="fas fa-check-circle" /> Rewiring&nbsp;&amp; Upgrades
              </li>
              <li>
                <i className="fas fa-check-circle" /> Switchboard Upgrades
              </li>
              <li>
                <i className="fas fa-check-circle" /> Lighting&nbsp;/ Power Circuits
              </li>
              <li>
                <i className="fas fa-check-circle" /> Data&nbsp;&amp; Comms Cabling
              </li>
              <li>
                <i className="fas fa-check-circle" /> Fault-finding&nbsp;&amp; Repairs
              </li>
            </ul>
            <Link to="/contact" className="btn">
              Get Wiring Quote
            </Link>
          </div>
        </div>
      </section>

      {/* ──────────────────────── BENEFITS ──────────────────────────── */}
      <section className="service-benefits" data-aos="fade-up">
        <h2 className="section-title">Why Choose Professional Wiring?</h2>
        <p className="section-description">
          The right wiring protects property and people.
        </p>

        <div className="benefits-grid">
          {[
            {
              icon: "fas fa-user-shield",
              title: "Enhanced Safety",
              text:
                "Proper wiring minimises the risk of electrical fires, shocks and outages.",
            },
            {
              icon: "fas fa-clipboard-check",
              title: "Code Compliance",
              text:
                "Fully compliant with SANS 10142-1 and all municipal regulations.",
            },
            {
              icon: "fas fa-tachometer-alt",
              title: "Optimal Performance",
              text:
                "Correct cable sizing delivers efficient power and extends appliance life.",
            },
            {
              icon: "fas fa-home",
              title: "Higher Property Value",
              text:
                "A professionally wired building is safer and more attractive to buyers.",
            },
          ].map((b, i) => (
            <div
              key={i}
              className="benefit-card"
              data-aos="fade-up"
              data-aos-delay={100 * (i + 1)}
            >
              <div className="benefit-icon">
                <i className={b.icon} />
              </div>
              <div className="benefit-content">
                <h3>{b.title}</h3>
                <p>{b.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ───────────────────────── PROCESS ──────────────────────────── */}
      <section className="service-process" data-aos="fade-up">
        <h2 className="section-title">Our Electrical Wiring Process</h2>
        <p className="section-description">
          A meticulous approach from consultation to certification.
        </p>

        <div className="process-steps">
          {[
            {
              num: 1,
              title: "Consultation & Design",
              text:
                "We gather requirements, plan layouts and verify load calculations.",
            },
            {
              num: 2,
              title: "Material Selection",
              text:
                "Only SANS-approved cables, conduits and components are used.",
            },
            {
              num: 3,
              title: "Professional Installation",
              text:
                "Certified electricians carry out neat, safe and compliant wiring.",
            },
            {
              num: 4,
              title: "Testing & Certification",
              text:
                "Rigorous testing followed by issue of a Certificate of Compliance.",
            },
          ].map(({ num, title, text }, i) => (
            <div
              key={i}
              className="process-step"
              data-aos="fade-up"
              data-aos-delay={100 * (i + 1)}
            >
              <div className="step-number">{num}</div>
              <h3>{title}</h3>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ────────────────────────── FAQ ─────────────────────────────── 
      <section className="faq-section" data-aos="fade-up">
        <h2 className="section-title">Wiring FAQs</h2>
        <div className="faq-container">
          {[
            {
              q: "How often should wiring be inspected?",
              a:
                "We recommend an inspection every 5-10 years, or whenever you buy/sell a property or undertake major renovations.",
            },
            {
              q: "What is a Certificate of Compliance (CoC)?",
              a:
                "A legal document confirming the installation is safe and complies with SANS 10142-1. Required for property transfers and new builds.",
            },
            {
              q: "Can I do my own wiring?",
              a:
                "Significant wiring work must be done by a registered electrician who can issue a CoC.",
            },
          ].map(({ q, a }, i) => (
            <div
              key={i}
              className="faq-item"
              data-aos="fade-up"
              data-aos-delay={100 * (i + 1)}
              onClick={e => e.currentTarget.classList.toggle("active")}
            >
              <div className="faq-question">
                <span>{q}</span>
                <i className="fas fa-chevron-down" />
              </div>
              <div className="faq-answer">
                <p>{a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
*/}
      {/* ───────────────────────── FINAL CTA ────────────────────────── */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-content">
          <h2>Need Expert Electrical Wiring?</h2>
          <p>
            Contact Mosike Electrical Contractors for safe, compliant, and
            reliable wiring solutions.
          </p>
          <div className="cta-buttons">
            <a href="tel:+27824989477" className="btn btn-white">
              <i className="fas fa-phone" /> Call (+27) 82 498 9477
            </a>
            <Link to="/contact" className="btn btn-outline">
              <i className="fas fa-envelope" /> Enquire Online
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
